import { call, put, takeLatest } from "redux-saga/effects";
import {
  deleteSavingsSource,
  addSavingsSource,
  updateSavingsSource,
} from "../slices/savingsSourcesSlice";
import { setData } from "../slices/capitalDetailsSlice";
import { api } from "../utils/api";

function* refreshCapitalDetailsSaga() {
  try {
    const {
      formattedBalance,
      difference,
      numberOfSources,
      lineChartData,
      portfolioChartData,
      categoriesChartData,
    } = yield call(api.getCapitalDetails);

    yield put(
      setData({
        formattedBalance,
        difference,
        numberOfSources,
        lineChartData,
        portfolioChartData,
        categoriesChartData,
      })
    );
    console.log("Capital Details refreshed:", savingsSourcesData);
  } catch (error) {
    console.error("Failed to refresh Capital Details", error);
  }
}

export default function* capitalDetailsSaga() {
  yield takeLatest(
    [deleteSavingsSource.type, addSavingsSource.type, updateSavingsSource.type],
    refreshCapitalDetailsSaga
  );
}
